import React, { useState } from 'react'
import './ContactForm.css'
import axios from 'axios'; // Ensure axios is installed

const ContactForm = ({ currentProperty }) => {

  // Inside the PropertyDetail component:
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: "I'm interested in this property and would like to schedule a viewing...",
    newsletter: false,
  });
  const [formStatus, setFormStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus(null);
    
    try {
      await axios.post('https://gladious-constructions.onrender.com/api/properties/contact', {
        ...formData,
        propertyTitle: currentProperty?.title || 'N/A',
        propertyPrice: currentProperty?.price || 'N/A',
        propertyArea: currentProperty?.area || 'N/A',
        propertyLocation: [
          currentProperty?.location?.address,
          currentProperty?.location?.city,
          currentProperty?.location?.country,
        ]
        .filter(Boolean)
        .join(', ') || 'N/A',
      });

      setFormStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: "I'm interested in this property and would like to schedule a viewing...",
        newsletter: false,
      }); 
    } catch (error) {
      setFormStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="name">Full Name</label>
          <div className="input-with-icon">
            <input
              type="text"
              id="name"
              name="name"
              placeholder="John Doe"
              value={formData.name}
              onChange={handleInputChange}
              required
              disabled={isSubmitting}
            />
            {/* SVG icon */}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <div className="input-with-icon">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="your@email.com"
              value={formData.email}
              onChange={handleInputChange}
              required
              disabled={isSubmitting}
            />
            {/* SVG icon */}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <div className="input-with-icon">
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="0320-7766542"
              value={formData.phone}
              onChange={handleInputChange}
              disabled={isSubmitting}
            />
            {/* SVG icon */}
          </div>
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="message">Your Message</label>
        <textarea
          id="message"
          name="message"
          rows="4"
          value={formData.message}
          onChange={handleInputChange}
          disabled={isSubmitting}
        />
      </div>


      <button 
        type="submit" 
        className="submit-button"
        disabled={isSubmitting}
      >
        <span>{isSubmitting ? 'Processing...' : 'Send Request'}</span>
        {/* SVG icon */}
      </button>

      {formStatus === 'success' && <p className="success-message">Message sent successfully!</p>}
      {formStatus === 'error' && <p className="error-message">Something went wrong. Please try again later.</p>}
    </form>
  )
}

export default ContactForm;